import { FC } from 'react';
import { Container } from '@material-ui/core';
import { GroupForm } from 'components/Forms';
import { useStyles } from './styles';

const Group: FC<any> = ({ type }) => {
  const classes = useStyles();

  return (
    <Container maxWidth='xl' className={classes.container}>
      <GroupForm type={type} />
    </Container>
  );
};

export default Group;
